import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { Input } from "../../../../ui/inputs/Input";

export default function PresentacionesAntReg({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Actualizar Prestaciones Antiguo Regimen</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 mb-2 p-2 d-flex flex-wrap">
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Cod. Integrante:' />
        </div>
        <div className="col-9 m-0 mb-2 p-0 pl-2">
          <Input label = 'Nombre:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Fecha de Ingreso:' type = 'date' />
        </div>
        <div className="col-6 m-0 mb-2 p-0 pl-2">
          <Input label = 'Articulo 666 LIteral A:' disabled />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Tiempo de Servicio al:' disabled  type = 'date' />
        </div>
        {/* NOTE: LA FECHA DE AQUI ES DADA POR EL TIEMPO DE SERVICIO */}
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = {`Sueldo al ${'19/06/97'}:`} type = 'date' /> 
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Sueldo Diario:' inputClassName = 'text-end' placeholder = '0.00'/>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Días por Año:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Monto a Pagar:' inputClassName = 'text-end' placeholder = '0.00'/>
        </div>
        <div className="col-9 m-0 mb-2 p-0">
          <Input label = 'Articulo 666 LIteral B:' disabled />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Tiempo de Servicio al:' disabled  type = 'date' />
        </div>
        {/* NOTE: LA FECHA DE AQUI ES DADA POR EL TIEMPO DE SERVICIO */}
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = {`Sueldo al ${'31/12/96'}:`} type = 'date' /> 
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Sueldo Diario:' inputClassName = 'text-end' placeholder = '0.00'/>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Monto a Pagar:' inputClassName = 'text-end' placeholder = '0.00' />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Meses para Sumar Intereses:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Adelanto Prestaciones:' inputClassName = 'text-end' placeholder = '0.00'/>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Total a Pagar:' inputClassName = 'text-end' placeholder = '0.00' />
        </div>
      </Modal.Body>
    </Modal>
  );
}
